<template>
    <div ref="cardReceiveDom">
        <sendRecord v-for="(v, i) in recordList" :key="v.id" :record="v" @delRecord="delRecordCallback" />
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed, toRef} from "vue";
    import record1Api from "@/request/record1Api"
    import {useUserinfo} from "@/stores/userinfo";
    import {useCardinfo} from "@/stores/cardinfo";
    import myUtil from "@/util/util"
    import sendRecord from "@/components/shopopee/record1/sendRecord"

    const { proxy } = getCurrentInstance();

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())
    //響應機制的cardinfo
    const cardInfoRef = toRef(useCardinfo())

    const recordList = ref([])

    const refWidth = ref(425)

    function getRecordList() {
        const request = record1Api.getMyMemberworkByRecord1
        const params = request.getParams()

        params.login = userInfoRef.value.login

        request.send(
            params,
            fillRecord
        )
    }

    function fillRecord(res) {
        if (res.code == 200){
            recordList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
            recordList.value = []
        }
    }

    function delRecordCallback(record1Id){
        for (let i=0; i<recordList.value.length; i++){
            const obj = recordList.value[i]

            if (obj.record1Id == record1Id){
                recordList.value.splice(i, 1)
                break
            }
        }
    }

    onMounted(() => {
        refWidth.value = proxy.$refs.cardReceiveDom.offsetWidth

        getRecordList()
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }
</style>